import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { LoadModal } from "../../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import Truncate from "react-truncate"
import { confirmAlert } from "react-confirm-alert"
class TableDiarioOcorrencias extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.getDiario = this.getDiario.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteDiarioOcorrencia(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  getDiario(id) {
    this.toggleLoadModal()
    ApiHelper.printDiarioOcorrencias(id, (diario, error) => {
      this.toggleLoadModal()
      if (diario) {
        var url = URL.createObjectURL(diario)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Diário de ocorrências:" + id + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var buttons = [
      {
        title: "Criar diário de ocorrências",
        link: "/diarioocorrencias/create",
        icon: "control_point"
      },
      {
        title: "Diários de ocorrências deletados",
        link: "/diarioocorrencias/trash",
        icon: "delete"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar diário de ocorrências"
        >
          {this.props.rows.map((row, key) => {
            return (
              <div key={key} className="col-md-4">
                <div className="card">
                  <div
                    className="card-header"
                    data-background-color={this.props.backgroundColor}
                  >
                    <h4 className="title text-center col-md-offset-right-1">
                      {"Contrato Nº " + row.contrato.num_contrato}
                    </h4>
                    <p className="category text-center col-md-offset-right-1">
                      {"Criado em " + Moment(row.created_at).format("D/MM/Y")}
                    </p>
                  </div>
                  <div className="diario-quote col-md-12">
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ padding: 0 }}
                        data-background-color={this.props.backgroundColor}
                      >
                        <h5 className="title text-center">
                          Execução contratual
                        </h5>
                        <p
                          style={{ marginTop: -8 }}
                          className="category text-center col-md-offset-right-1"
                        >
                          {"Data: " +
                            (row.dt_exec_contratual
                              ? Moment(row.dt_exec_contratual).format("D/MM/Y")
                              : "N/A")}
                        </p>
                      </div>
                      <div className="card-content">
                        <Truncate
                          lines={1}
                          ellipsis={<span className="label-quote">...</span>}
                        >
                          {row.exec_contratual}
                        </Truncate>
                      </div>
                    </div>
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ padding: 0 }}
                        data-background-color={this.props.backgroundColor}
                      >
                        <h5 className="title text-center">Providências</h5>
                        <p
                          style={{ marginTop: -8 }}
                          className="category text-center col-md-offset-right-1"
                        >
                          {"Data: " +
                            (row.dt_providencias
                              ? Moment(row.dt_providencias).format("D/MM/Y")
                              : "N/A")}
                        </p>
                      </div>
                      <div className="card-content">
                        <Truncate
                          lines={0}
                          ellipsis={<span className="label-quote">...</span>}
                        >
                          {row.providencias}
                        </Truncate>
                      </div>
                    </div>
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ padding: 0 }}
                        data-background-color={this.props.backgroundColor}
                      >
                        <h5 className="title text-center">Resultados</h5>
                        <p
                          style={{ marginTop: -8 }}
                          className="category text-center col-md-offset-right-1"
                        >
                          {"Data: " +
                            (row.dt_resultados
                              ? Moment(row.dt_resultados).format("D/MM/Y")
                              : "N/A")}
                        </p>
                      </div>
                      <div className="card-content">
                        <Truncate
                          lines={1}
                          ellipsis={<span className="label-quote">...</span>}
                        >
                          {row.resultados}
                        </Truncate>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-md-offset-3">
                    <Link
                      title="Editar diário de ocorrências"
                      className="btn btn-primary btn-simple btn-xs"
                      to={"diarioocorrencias/edit/" + row.id}
                    >
                      <i className="material-icons">edit</i>
                    </Link>
                    <button
                      type="button"
                      rel="tooltip"
                      title="Remove diário de ocorrências"
                      onClick={() => this.delete(row.id)}
                      className="btn btn-danger btn-simple btn-xs"
                    >
                      <i className="material-icons">close</i>
                    </button>
                    <button
                      type="button"
                      onClick={() => this.getDiario(row.id)}
                      rel="tooltip"
                      title="Imprimir diário de ocorrências"
                      className="btn btn-info btn-simple btn-xs"
                    >
                      <i className="material-icons">print</i>
                    </button>
                  </div>
                </div>
              </div>
            )
          })}
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableDiarioOcorrencias)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/diario-ocorrencias/TableDiarioOcorrencias.js